

import { ICategories } from '../models/categoriesresponse.model';


export interface ICategoriesState {
    Categories: ICategories;
}

export const initialCategoriesState: ICategoriesState = {
    Categories: null
};